module.exports = __webpack_public_path__ + "img/5.0e08fb07.jpg";